import React from 'react';
import { ThemeProvider } from '@/app/providers/ThemeProvider';
import { StoreProvider } from '@/app/providers/StoreProvider';
import { RouterProvider } from '@/app/providers/RouterProvider';
import { FloatingProvider } from '@/shared/lib/components/FloatingProvider';
import '@/widgets/layouts/MainLayout/MainLayout';

function App() {
  return (
    <FloatingProvider>
      <ThemeProvider>
        <StoreProvider>
          <div className='app'>
            <RouterProvider />
          </div>
        </StoreProvider>
      </ThemeProvider>
    </FloatingProvider>
  );
}

export default App;
